import React from "react";
import Layout from "../components/Layout";

const pageDescription =
  "Host a Virtual Horse Race Night and have a night of fast-paced fun on Zoom. Invite all your mates and have some fun cheering on the horses. Perfect for parties and team building events!";
const pageTitle = "Track Night: Virtual Horse Race Night Game";

function VitualHorseRaceNights(ctx) {
  return (
    <Layout
      canonical="https://www.track-night.com/virtual-horse-race-nights"
      brand={ctx.brand}
      showHeaderLinks={true}
      ogDescription={pageDescription}
      ogTitle={pageTitle}
    >
      <div className="container">
        <div className="section">
          <h1 className="title">Virtual Horse Racing Nights</h1>
          <div className="columns">
            <div className="column">
              <p>
                Track Night is a fast-paced virtual horse racing game, designed
                to be played with friends, family and colleagues of all ages
                either in person or over a video call.
              </p>
              <p>
                <strong>
                  There&apos;s no real gambling, it&apos;s all just for fun.
                </strong>
              </p>
              <p>
                Each Track Night is made up of 6 races using real footage from
                horse racing events and can last anywhere from 30 minutes to
                several hours (if it’s played as breakouts at conferences!).
              </p>
              <p>
                Track Night can be played in person with everyone sharing one
                screen to watch the races on, or it can be played remotely with
                all players dialling in to a video call and the host sharing
                their screen. The only thing each player will need is their
                mobile phones to place their just-for-fun bets.
              </p>
              <br />
              <p>
                What are you waiting for, grab your mates and head to the track
                to make your next get together a night at the virtual races!
              </p>
              <br />
              <br />
              <a
                className="button is-large is-fullwidth is-success"
                href="/meets/new"
              >
                Get Started
              </a>
            </div>
            <div className="column">
              <img src="hero-image-small.jpg" alt="Virtual horse race nights" />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        h1 {
          padding-bottom: 0.5em;
        }
        h2 {
          padding-bottom: 0.5em;
        }
      `}</style>
    </Layout>
  );
}

export default VitualHorseRaceNights;
